import { PARTNERS } from "../data/content";

export const PartnersMarquee = () => {
  const items = [...PARTNERS, ...PARTNERS];
  return (
    <section
      data-testid="partners-marquee"
      className="border-y border-black/5 bg-[#F8FAFC] py-10 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex items-center gap-6 mb-6">
        <span className="text-[10px] uppercase tracking-[0.35em] text-[#0A192F]/60">
          Trusted by institutions & operators
        </span>
        <span className="flex-1 h-px bg-black/10" />
      </div>
      <div className="relative w-full overflow-hidden no-scrollbar">
        <div className="marquee-track flex gap-16 whitespace-nowrap w-max">
          {items.map((p, i) => (
            <span
              key={i}
              className="font-serif text-2xl lg:text-3xl text-[#0A192F]/70 hover:text-[#0A192F] transition-colors"
            >
              {p}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
